import styled from 'styled-components';

import { AccountOfferingBalance, Offering } from '@arrived/models';

import { PositionDetailSecondaryTypography } from './offering/PositionDetailSecondaryTypography';

import { OfferingBalance, OfferingSharePrice, OfferingTransactionList } from './offering';

const StyledPropertyDetailsOfferingBalance = styled.div`
  padding: ${(props) => props.theme.spacing(0, 4)};
  margin-top: ${({ theme }) => theme.spacing(2)};
  margin-bottom: ${({ theme }) => theme.spacing(4)};

  .offering-share-price,
  .offering-balance,
  .offering-transaction-list {
    margin-bottom: ${({ theme }) => theme.spacing(3)};
  }

  ${({ theme }) => theme.breakpoints.down('md')} {
    padding: ${({ theme }) => theme.spacing(0, 2)};

    .offering-share-price,
    .offering-balance,
    .offering-transaction-list {
      padding: ${({ theme }) => theme.spacing(0)};
      margin-bottom: ${({ theme }) => theme.spacing(2)};
    }
  }
`;

export interface PropertyDetailsOfferingBalanceProps {
  offeringBalance: AccountOfferingBalance;
  offering: Offering;
}

export const PropertyDetailsOfferingBalance = ({ offeringBalance, offering }: PropertyDetailsOfferingBalanceProps) => {
  const { appreciation, totalSharesCount, totalValue, rentalIncome } = offeringBalance;

  return (
    <StyledPropertyDetailsOfferingBalance>
      <PositionDetailSecondaryTypography className="offering-share-price">
        <OfferingSharePrice offeringId={offering.id} />
      </PositionDetailSecondaryTypography>
      <OfferingBalance
        className="offering-balance"
        appreciation={appreciation}
        equity={totalValue}
        numShares={totalSharesCount}
        offering={offering}
        rentalIncome={rentalIncome}
      />
      <OfferingTransactionList className="offering-transaction-list" offeringId={offering.id} />
    </StyledPropertyDetailsOfferingBalance>
  );
};
